const EXHIBITIONS_DATA = {
  exhibitions: [
    {
      id: 0,
      exhibition_title: "MARCHÉ ARTISANAL JAPON, TOURS",
      start_date: "2024/5/26",
      end_date: "2024/5/26",
      start_time: "10:30",
      end_time: "19:00",
      location: "YOÏSHO",
      address: "11, avenue Grammont Tours",
      exhibition_image_url:
        "https://live.staticflickr.com/65535/53732647335_5b6af48c0b_h.jpg",
      exhibitors: ["Tsubaki création", "Nami Créations", "GOEN", "AT bijoux"],
      about_exhibition:
        "Créateurs japonais vendent des produits faits à la main",
      exhibition_url: "",
    },
    {
      id: 1,
      exhibition_title: "MARCHÉ ARTISANAL JAPON, TOURS",
      start_date: "2024/6/23",
      end_date: "2024/6/23",
      start_time: "10:30",
      end_time: "19:00",
      location: "YOÏSHO",
      address: "11, avenue Grammont Tours",
      exhibition_image_url:
        "https://live.staticflickr.com/65535/53732647335_5b6af48c0b_h.jpg",
      exhibitors: [
        "Tsubaki création",
        "Nami Créations",
        "GOEN",
        "FUMIHITO ONDA Massage",
      ],
      about_exhibition:
        "Créateurs japonais vendent des produits faits à la main",
      exhibition_url: "",
    },
    {
      id: 2,
      exhibition_title: "MARCHÉ ARTISANAL JAPON, TOURS",
      start_date: "2024/7/14",
      end_date: "2024/7/14",
      start_time: "10:30",
      end_time: "19:00",
      location: "YOÏSHO",
      address: "11, avenue Grammont Tours",
      exhibition_image_url:
        "https://live.staticflickr.com/65535/53732647335_5b6af48c0b_h.jpg",
      exhibitors: ["Tsubaki création", "Nami Créations", "GOEN"],
      about_exhibition:
        "Créateurs japonais vendent des produits faits à la main",
      exhibition_url: "",
    },
    {
      id: 3,
      exhibition_title: "MARCHÉ ARTISANAL JAPON, TOURS",
      start_date: "2024/7/27",
      end_date: "2024/7/27",
      start_time: "11:00",
      end_time: "20:30",
      location: "YOÏSHO",
      address: "11, avenue Grammont Tours",
      exhibition_image_url:
        "https://live.staticflickr.com/65535/53732422478_a73a9d995d_h.jpg",
      exhibitors: ["Tsubaki création", "Nami Créations", "Biscuits o riz"],
      about_exhibition:
        "Créateurs japonais vendent des produits faits à la main",
      exhibition_url: "",
    },
  ],
};

export default EXHIBITIONS_DATA;
